export interface UpdateContentRequest {
    /**
     * 章节类型
     */
    chapter_type: string;
    /**
     * 替换内容
     */
    content: string;
    /**
     * 错误id列表
     */
    errors: string[];
    /**
     * 任务ID
     */
    task_id: string;
    /**
     * 实施例编号
     */
    embodiment_number?: number;
    /**
     * 实施例类型
     */
    embodiment_type?: string;
    /**
     * 段落分割索引
     */
    split_index: number;
}

export interface UpdateContentResponse {
    success: boolean;
}

export interface UpdateContentApi {
    updateContent: (data: UpdateContentRequest) => Promise<UpdateContentResponse>;
}

export const UpdateContentApi = Symbol('UpdateContentApi');


